// Puesta en marcha de un agente: cinco pasos en orden. Función pura (sin red) para que la lista, el detalle y las pruebas
// calculen lo mismo.

export const STEP_KEYS = ['credential', 'prompt', 'published', 'channel', 'engine'];

export const STEP_LABELS = {
  credential: 'Clave de OpenAI',
  prompt: 'Instrucciones',
  published: 'Publicado',
  channel: 'Canal conectado',
  engine: 'Motor encendido',
};

const ACTIVE_CHANNEL = ['connected', 'degraded'];

/**
 * @param {{ agent: object, project?: object, credential?: object|null, draft?: object|null, published?: object|null, connections?: object[] }} d
 * @returns {{ steps: {key:string,label:string,state:'done'|'next'|'pending'|'problem',detail?:string}[], done:number, next:string|null }}
 */
export function readiness({ agent, project, credential, draft, published, connections = [] }) {
  const hasPrompt = Boolean((draft?.prompt || published?.prompt || '').trim());
  const live = connections.filter((c) => ACTIVE_CHANNEL.includes(c.status));
  const raw = {
    credential: credential?.status === 'active' ? 'done' : credential?.status === 'error' ? 'problem' : 'todo',
    prompt: hasPrompt ? 'done' : 'todo',
    published: agent?.status === 'published' && agent?.published_version ? 'done' : 'todo',
    channel: live.length ? 'done' : connections.some((c) => c.status === 'error') ? 'problem' : 'todo',
    engine: project?.engine === 'runtime' ? 'done' : 'todo',
  };
  const detail = {
    credential: credential?.status === 'error' ? 'OpenAI rechazó la clave' : credential ? `Termina en ${credential.last4}${credential.is_public ? ' · pública' : ''}` : 'Sin clave',
    prompt: hasPrompt ? 'Escritas' : 'Vacías',
    published: raw.published === 'done' ? `Versión ${agent.published_version}` : 'Solo borrador',
    channel: live.length ? live.map((c) => CHANNEL_NAMES[c.channel] || c.channel).join(', ') : 'Ninguno',
    engine: project?.engine === 'runtime' ? 'Atiende el motor nuevo' : 'Lo atiende n8n',
  };
  let nextKey = null;
  const steps = STEP_KEYS.map((key) => {
    let state = raw[key] === 'done' ? 'done' : raw[key] === 'problem' ? 'problem' : 'pending';
    if (state !== 'done' && nextKey === null) { nextKey = key; if (state === 'pending') state = 'next'; }
    return { key, label: STEP_LABELS[key], state, detail: detail[key] };
  });
  return { steps, done: steps.filter((s) => s.state === 'done').length, next: nextKey };
}

export const CHANNEL_NAMES = { telegram: 'Telegram', whatsapp: 'WhatsApp', web: 'Web', whatsapp_call: 'Llamadas', instagram: 'Instagram' };

/** ¿El borrador tiene cambios respecto a la versión publicada? */
export function hasUnpublishedChanges(draft, published) {
  if (!draft) return false;
  if (!published) return Boolean((draft.prompt || '').trim());
  return (draft.prompt || '') !== (published.prompt || '') || JSON.stringify(draft.config || {}) !== JSON.stringify(published.config || {});
}

// ── Agentes externos (script 31) ──
export const MANAGED_LABELS = { n8n: 'n8n', web: 'página web', other: 'otro sistema' };
export const isExternal = (agent) => Boolean(agent?.managed_by) && agent.managed_by !== 'platform';
/** Lo que significa "externo", igual en todas las pantallas. */
export const EXTERNAL_MEANING = 'Externo quiere decir que el agente funciona en otro sistema (un flujo de n8n, la página web del cliente u otro servicio). Aquí solo se registra para tenerlo a la vista con los demás: sus instrucciones, canales y respuestas se cambian donde vive.';
